import * as animations from '.';

export const LottieAnimations = animations;
